import { escapeRegexpString } from '@direct-frontend/stdlib';
import { MaskitoPostprocessor } from '@maskito/core';

/**
 * It removes floating decimal separator if no decimal numbers provided.
 * @example 1 000, => blur => 1 000
 */
export function dropFloatingDecimalSymbolPostprocessor(decimalSeparator: string): MaskitoPostprocessor {
    const trimFloatingDecimalSeparator = (value: string): string => {
        const escapedDecimalSeparator = escapeRegexpString(decimalSeparator);

        return value.replace(new RegExp(`(.*)${escapedDecimalSeparator}$`), '$1');
    };

    return ({ value, selection }) => {
        const [from, to] = selection;
        return {
            value: trimFloatingDecimalSeparator(value),
            selection: [from, to],
        };
    };
}
